import * as React from 'react';
import { styled } from '@mui/material/styles';
import Switch from '@mui/material/Switch';
import { useTranslation } from 'react-i18next';
import { Tooltip } from '@mui/material';

interface LanguageSwitchProps {
    checked: boolean;
    onChange: () => void;
}

const LanguageSwitch = styled(Switch)(({ theme }) => ({
    width: 62,
    height: 34,
    padding: 7,
    '& .MuiSwitch-switchBase': {
        margin: 1,
        padding: 0,
        transform: 'translateX(6px)',
        transition: 'transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)',
        '&.Mui-checked': {
            color: '#fff',
            transform: 'translateX(22px)',
            '& .MuiSwitch-thumb': {
                backgroundImage: 'linear-gradient(135deg, #1976D2 0%, #1565C0 100%)',
                boxShadow: '0 0 10px rgba(25, 118, 210, 0.5)',
            },
            '& .MuiSwitch-thumb:before': {
                backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 20 20"><text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" font-family="Cairo,Roboto" font-weight="600" font-size="11" fill="${encodeURIComponent(
                    '#fff',
                )}">EN</text></svg>')`,
            },
            '& + .MuiSwitch-track': {
                opacity: 1,
                backgroundColor: '#B0BEC5',
                ...theme.applyStyles('dark', { backgroundColor: '#546E7A' }),
            },
        },
    },
    '& .MuiSwitch-thumb': {
        backgroundImage: 'linear-gradient(135deg, #43A047 0%, #2E7D32 100%)',
        width: 32,
        height: 32,
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.2)',
        transition: 'background 0.3s ease, box-shadow 0.3s ease',
        '&::before': {
            content: "''",
            position: 'absolute',
            width: '100%',
            height: '100%',
            left: 0,
            top: 0,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 20 20"><text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" font-family="Cairo,Roboto" font-weight="600" font-size="11" fill="${encodeURIComponent(
                '#fff',
            )}">AR</text></svg>')`,
        },
    },
    '& .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: '#B0BEC5',
        ...theme.applyStyles('dark', { backgroundColor: '#546E7A' }),
        borderRadius: 20 / 2,
        transition: 'background-color 0.3s ease',
    },
}));

export default function LanguageSwitchComponent({ checked, onChange }: LanguageSwitchProps) {
    const { t } = useTranslation();

    return (
        <Tooltip title={t('common.switchLanguage')} arrow>
            <LanguageSwitch
                checked={checked}
                onChange={onChange}
                inputProps={{ 'aria-label': t('common.switchLanguage') }}
            />
        </Tooltip>
    );
}
